import Badge from "@kit/design/badge"

export const PaidFeatureBadge = () => {
  return (
    <Badge
      color="blue"
      variant="light"
      size="sm"
      className="ml-2 bg-blue-100 text-blue-800"
    >
      Paid feature
    </Badge>
  )
}
